import type { FC, PropsWithChildren } from 'react';
import { cloneElement, Children } from 'react';

import type { IPublisher } from '../../models';

import { groupByPropKey, injectPublishEvents } from './helpers';

export const Publisher: FC<PropsWithChildren<IPublisher>> = ({
    callbacks,
    children,
    ...restProps
}) => {
    if (!callbacks) return children;

    const child = Children.only(children);

    const groupedCallbacks = groupByPropKey(callbacks);

    const newProps = injectPublishEvents(groupedCallbacks, child.props);

    return cloneElement(child, {
        ...restProps,
        ...newProps,
    });
};
